<template>
	<div class='plots-component'>
		
		<!-- <div class='title'>
			<span>Буреломы, ветровалы</span>
		</div> -->
		<PlotsVisualLandTax/>


		<div class='open-btn-block'>
			<button @click='openModalVbSheet' :class="{ red: !bvRecountCheck }" class='tree-list-btn'>Открыть ведомость</button>
			<PMessage v-if="bvRecountCheck" severity="success" :closable="false">Ведомость заполнена</PMessage>
			<PMessage v-else severity="error" :closable="false">Ведомость не заполнена (заполнена не по всем породам)</PMessage>
		</div>

		<CustomModal ref='modalVbSheet'>
			<VisualLandSheet/>
		</CustomModal>
	</div>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex';
	
	import VisualLandSheet from './RecountVisualLand__sheet';
	import PlotsVisualLandTax from './RecountVisualLand__tax';

	export default {
		name: 'PlotsVb',
		components: {
			VisualLandSheet,
			PlotsVisualLandTax
		},

		computed: {
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},
			...mapState("selectedLpo/recount", {
				speciesListTax: state => state.speciesListTax,
				vbList: state => state.vbList,
			}),
			...mapGetters('selectedLpo/recount', ['bvRecountCheck']),
		},
		methods: {
			openModalVbSheet() {
				this.$refs['modalVbSheet'].open();
			},


		}
	};
</script>

<!-- <style scoped src='@/style/flex.css'></style> -->
<!-- <style scoped src='@/style/table.css'></style> -->

<style scoped>

	.tree-list-btn {
		margin-right: 10px;
		border: 2px solid green;
		background: #fcf9fa; /* Цвет фона */
    	padding: 0.3em 0.5em; /* Поля вокруг текста */
	}
	.red {
		border: 2px solid #e34761;
	}

	.title {
		font-size: 1rem;
		font-weight: bold;
		font-style: italic;
		margin-bottom: 10px;
	}

	.open-btn-block{
		margin-top: 10px;
	}

	.toggle-recount-btn {
		margin-top: 20px;
	}

	.vb-sheet-block {
		margin-top: 2.5rem;
	}
</style>